const COORDINATOR = {
  sub: "lk-oauth2|728859",
  user_name: "ekaterina.abrosimova@jugru.org ",
  displayName: "COORDINATOR",
  profile: "https://oh-my-duck-dev.jugru.org/users/z21Ad2",
  iss: "lk",
  authorities: ["regular"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 728859,
  scope: ["regular"],
  lk_session_id: 156321,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "EN",
  jti: "fcb94535-3290-4916-a92e-e4ff307306ba",
  email: "ekaterina.abrosimova@jugru.org ",
};

const PK_MEMBER = {
  sub: "lk-oauth2|2378",
  user_name: "vladimir.krasilschik@gmail.com",
  displayName: "PK_MEMBER",
  profile: "https://oh-my-duck-dev.jugru.org/users/qLPavk",
  iss: "lk",
  authorities: ["regular"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 2378,
  scope: ["regular"],
  lk_session_id: 156322,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "RU",
  jti: "bcc0645f-0750-413c-823e-50ee17b85e36",
  email: "vladimir.krasilschik@gmail.com",
};

const GLOBAL_ADMIN = {
  sub: "lk-oauth2|716672",
  user_name: "nikolay.molchanov@jugru.org",
  displayName: "GLOBAL_ADMIN",
  profile: "https://oh-my-duck-dev.jugru.org/users/qLPavk",
  iss: "lk",
  authorities: ["regular", "admin"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 716672,
  scope: ["regular"],
  lk_session_id: 156322,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "RU",
  jti: "bcc0645f-0750-413c-823e-50ee17b85e36",
  email: "nikolay.molchanov@jugru.org",
};

const SPEAKER = {
  sub: "lk-oauth2|719287",
  user_name: "sunex.development@gmail.com",
  displayName: "SPEAKER",
  profile: "https://oh-my-duck-dev.jugru.org/users/qLPavk",
  iss: "lk",
  authorities: ["regular"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 719287,
  scope: ["regular"],
  lk_session_id: 156322,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "RU",
  jti: "bcc0645f-0750-413c-823e-50ee17b85e36",
  email: "sunex.development@gmail.com",
};

const SUPPORT_LEAD = {
  sub: "lk-oauth2|760868",
  user_name: "eugeny.potemkin@jugru.org",
  displayName: "SUPPORT_LEAD",
  profile: "https://oh-my-duck-dev.jugru.org/users/qLPavk",
  iss: "lk",
  authorities: ["regular"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 760868,
  scope: ["regular"],
  lk_session_id: 156322,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "RU",
  jti: "bcc0645f-0750-413c-823e-50ee17b85e36",
  email: "eugeny.potemkin@jugru.org",
};

const MANAGER = {
  sub: "lk-oauth2|716672",
  user_name: "nikolay.molchanov@jugru.org",
  displayName: "MANAGER",
  profile: "https://oh-my-duck-dev.jugru.org/users/qLPavk",
  iss: "lk",
  authorities: ["regular"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 716672,
  scope: ["regular"],
  lk_session_id: 156322,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "RU",
  jti: "bcc0645f-0750-413c-823e-50ee17b85e36",
  email: "nikolay.molchanov@jugru.org",
};

const OWNER = {
  sub: "lk-oauth2|716681",
  user_name: "alexey@jugru.org",
  displayName: "OWNER",
  profile: "https://oh-my-duck-dev.jugru.org/users/qLPavk",
  iss: "lk",
  authorities: ["regular"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 716681,
  scope: ["regular"],
  lk_session_id: 156322,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "RU",
  jti: "bcc0645f-0750-413c-823e-50ee17b85e36",
  email: "alexey@jugru.org",
};

const EDITOR = {
  sub: "lk-oauth2|776631",
  user_name: "vanda.pavlova@jugru.org",
  displayName: "EDITOR",
  profile: "https://oh-my-duck-dev.jugru.org/users/qLPavk",
  iss: "lk",
  authorities: ["regular"],
  picture: "",
  client_id: "srm-client",
  lk_user_id: 776631,
  scope: ["regular"],
  lk_session_id: 156322,
  exp: Math.floor(Date.now() / 1000) + 7 * 24 * 60 * 60,
  lang: "RU",
  jti: "bcc0645f-0750-413c-823e-50ee17b85e36",
  email: "vanda.pavlova@jugru.org",
};

type SRM_MOCK_USERS_TYPE =
  | "COORDINATOR"
  | "PK_MEMBER"
  | "GLOBAL_ADMIN"
  | "OWNER"
  | "MANAGER"
  | "EDITOR"
  | "SUPPORT_LEAD"
  | "SPEAKER";

export const SRM_MOCK_USERS: Record<SRM_MOCK_USERS_TYPE, object> = {
  COORDINATOR,
  PK_MEMBER,
  GLOBAL_ADMIN,
  OWNER,
  MANAGER,
  EDITOR,
  SUPPORT_LEAD,
  SPEAKER,
};
